import request from '../utils/request'
import {API} from '../utils/constant'

export default {
  login (params) {
    return request.post(API.LOGIN, params)
  },
  forgotPassword (params) {
    return request.post(API.FORGOT_PASSWORD, params)
  },
  checkToken (params) {
    return request.get(API.CHECK_TOKEN + params, params)
  },
  changePassword (params) {
    return request.put(API.RESET_PASSWORD + params.token, params.new_password)
  },
  accountChangePassword (params) {
    return request.put(API.PROFILE_CHANGE_PASSWORD, params)
  },
  registerContact (params) {
    return request.post(API.CONTACT, params)
  },
  getProfile (params) {
    return request.get(API.PROFILE, params)
  },
  editProfile (params) {
    return request.post(API.PROFILE, params)
  },
  getUserCompanyIds (params) {
    return request.get(API.USER_COMPANY_IDS, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js